module.exports = __webpack_public_path__ + "static/media/vf_mwallet_core.25376f2b.svg";